module.exports = __webpack_public_path__ + "images/logos/snapbox-logo.png";